import type { GetComponentData } from '@preply/ds-visual-coverage-core'
import { createCalculateDsVisualCoverages } from '@preply/ds-visual-coverage-web'

import type { CoverageData } from '../../types'

export interface CollectCoverageDataParams {
  getComponentData: GetComponentData<Element>
  log: boolean
  route: string
}

export function collectCoverageData(
  params: CollectCoverageDataParams,
): Promise<CoverageData> {
  return new Promise((resolve, reject) => {
    const calc = createCalculateDsVisualCoverages({
      getComponentData: params.getComponentData,
      log: params.log,
    })

    const timeoutId = setTimeout(() => {
      calc.cancel()
      reject(new Error('[DS Visual Coverage] Calculation timed out after 30s'))
    }, 30_000)

    calc.run({
      onComplete: (result) => {
        clearTimeout(timeoutId)
        const data: CoverageData = {
          containers: result.dsVisualCoverageResults.map((r) => ({
            container: r.coverageContainerAttributeValue ?? 'body',
            coveragePercent: Number.isNaN(r.coverage) ? 0 : r.coverage,
            pixelCounts: r.readablePixelCounts,
            totalDuration: r.totalDuration,
            warnings: r.warnings ?? [],
          })),
          route: params.route,
          timestamp: new Date().toISOString(),
          totalDuration: result.totalDuration,
          url: globalThis.location?.href ?? '',
        }
        resolve(data)
      },
      onError: (error) => {
        clearTimeout(timeoutId)
        reject(error)
      },
    })
  })
}
